module.exports = __webpack_public_path__ + "static/img/la-petite-roche-novalloy-signs04.825d91b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/la-petite-roche/la-petite-roche-novalloy-signs04.jpg
// module id = 931
// module chunks = 0